<template>
  <div class="contact-view">
    <!-- Hero -->
    <section class="hero">
      <div class="container">
        <h1 class="hero-title">광고 및 마케팅 서비스</h1>
        <p class="hero-subtitle">분양쟁이와 함께 성공적인 분양 마케팅을 시작하세요</p>
      </div>
    </section>

    <div class="container">
      <!-- 서비스 탭 -->
      <div class="tabs-wrapper">
        <div class="tabs">
          <button
            v-for="tab in tabs"
            :key="tab.id"
            :class="['tab', { active: activeTab === tab.id }]"
            @click="activeTab = tab.id"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" :d="tab.icon" />
            </svg>
            {{ tab.name }}
          </button>
        </div>
      </div>

      <!-- 탭 컨텐츠 -->
      <div class="tab-content">
        <!-- 분양쟁이 광고 -->
        <div v-if="activeTab === 'platform'" class="tab-panel">
          <div class="section">
            <h2 class="section-title">배너 광고</h2>
            <div class="cards-grid">
              <div class="service-card featured">
                <div class="card-badge">인기</div>
                <div class="card-header">
                  <h3>탑배너</h3>
                  <p class="price">80만원 <span>/주</span></p>
                </div>
                <ul class="features">
                  <li>모든 페이지 최상단 고정</li>
                  <li>장점</li>
                  <li>장점</li>
                  <li>장점</li>
                </ul>
              </div>

              <div class="service-card">
                <div class="card-header">
                  <h3>메인배너</h3>
                  <p class="price">50만원 <span>/주</span></p>
                </div>
                <ul class="features">
                  <li>홈 첫 화면 대형 슬라이드</li>
                  <li>장점</li>
                  <li>장점</li>
                  <li>장점</li>
                </ul>
              </div>
                            <div class="service-card">
                <div class="card-header">
                  <h3>마이페이지 사이드바 배너</h3>
                  <p class="price">50만원 <span>/주</span></p>
                </div>
                <ul class="features">
                  <li>사이드바배너</li>
                  <li>장점</li>
                  <li>장점</li>
                  <li>장점</li>
                </ul>
              </div>

              <div class="service-card">
                <div class="card-header">
                  <h3>서브배너</h3>
                  <p class="price">30만원 <span>/주</span></p>
                </div>
                <ul class="features">
                  <li>홈 중간 위치 (파트너스 위)</li>
                  <li>장점</li>
                  <li>장점</li>
                  <li>장점</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="section">
            <h2 class="section-title">공고 광고</h2>
            <div class="comparison-table">
              <table>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th>기본</th>
                    <th>급구</th>
                    <th>분쟁PICK</th>
                    <th class="highlight">프리미엄</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="label">검색 순위</td>
                    <td>4순위</td>
                    <td>3순위</td>
                    <td>2순위</td>
                    <td class="highlight"><strong>1순위</strong></td>
                  </tr>
                  <tr>
                    <td class="label">배지</td>
                    <td>-</td>
                    <td><span class="badge urgent">급구</span></td>
                    <td><span class="badge pick">PICK</span></td>
                    <td class="highlight"><span class="badge premium">프리미엄</span></td>
                  </tr>
                  <tr>
                    <td class="label">홈 전용 섹션</td>
                    <td>신규 공고</td>
                    <td>급구 (12개)</td>
                    <td>분쟁PICK (12개)</td>
                    <td class="highlight">모든 섹션 최상단</td>
                  </tr>
                  <tr>
                    <td class="label">클릭률</td>
                    <td>100%</td>
                    <td>150%</td>
                    <td>200%</td>
                    <td class="highlight"><strong>300%</strong></td>
                  </tr>
                  <tr>
                    <td class="label">가격/주</td>
                    <td><strong>무료</strong></td>
                    <td><strong>10만원</strong></td>
                    <td><strong>15만원</strong></td>
                    <td class="highlight"><strong>20만원</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="section">
            <h2 class="section-title">파트너스</h2>
            <div class="partners-card">
              <div class="partners-info">
                <h3>장기 브랜드 노출</h3>
                <p class="price">50만원 <span>/월</span></p>
                <ul class="features">
                  <li>홈 파트너스 섹션 8개 슬롯</li>
                  <li>회색 로고 2:1 비율</li>
                  <li>전용 페이지 링크</li>
                  <li>장기 브랜드 구축</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- 온라인 마케팅 -->
        <div v-if="activeTab === 'marketing'" class="tab-panel">
          <div class="marketing-grid">
            <div class="marketing-card">
              <div class="card-icon youtube">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </div>
              <div class="card-content">
                <h3>유튜브 마케팅</h3>
                <p>모델하우스 방문 촬영 → 전문 편집 → 유튜브 업로드 및 홍보</p>
                <div class="tags">
                  <span>검색광고</span>
                  <span>디스커버리</span>
                  <span>촬영 & 편집</span>
                </div>
              </div>
            </div>

            <div class="marketing-card">
              <div class="card-icon instagram">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </div>
              <div class="card-content">
                <h3>인스타그램 릴스</h3>
                <p>모델하우스 방문 촬영 → 숏폼 콘텐츠 제작 → 릴스 업로드 및 홍보</p>
                <div class="tags">
                  <span>릴스 제작</span>
                  <span>해시태그 최적화</span>
                  <span>타겟 광고</span>
                </div>
              </div>
            </div>

            <div class="marketing-card">
              <div class="card-icon facebook">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </div>
              <div class="card-content">
                <h3>SNS 광고 (페이스북/인스타그램)</h3>
                <p>4만여 회원 보유 당근 지역 기반 초정밀 타겟팅</p>
                <div class="tags">
                  <span>페이스북</span>
                  <span>인스타그램</span>
                  <span>당근마켓</span>
                </div>
              </div>
            </div>

            <div class="marketing-card">
              <div class="card-icon naver">
                <span class="naver-logo">N</span>
              </div>
              <div class="card-content">
                <h3>네이버 배너광고</h3>
                <p>PC 메인/모바일 타임보드, 롤링보드 프리미엄 위치 노출</p>
                <div class="tags">
                  <span>타임보드</span>
                  <span>롤링보드</span>
                  <span>스마트채널</span>
                </div>
              </div>
            </div>

            <div class="marketing-card">
              <div class="card-icon google">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                </svg>
              </div>
              <div class="card-content">
                <h3>구글 GDN 배너광고</h3>
                <p>여러 포털 사이트에 노출되는 구글 디스플레이 네트워크 광고</p>
                <div class="tags">
                  <span>디스플레이</span>
                  <span>GDN</span>
                  <span>리타게팅</span>
                </div>
              </div>
            </div>

            <div class="marketing-card">
              <div class="card-icon kakao">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 3c5.799 0 10.5 3.664 10.5 8.185 0 4.52-4.701 8.184-10.5 8.184a13.5 13.5 0 0 1-1.727-.11l-4.408 2.883c-.501.265-.678.236-.472-.413l.892-3.678c-2.88-1.46-4.785-3.99-4.785-6.866C1.5 6.665 6.201 3 12 3zm5.907 8.06l1.47-1.424a.472.472 0 0 0-.656-.678l-1.928 1.866V9.282a.472.472 0 0 0-.944 0v2.557a.471.471 0 0 0 0 .222V13.5a.472.472 0 0 0 .944 0v-1.363l.427-.413 1.428 2.033a.472.472 0 1 0 .773-.543l-1.514-2.155zm-2.958 1.924h-1.46V9.297a.472.472 0 0 0-.943 0v4.159c0 .26.21.472.471.472h1.932a.472.472 0 1 0 0-.944zm-5.857-1.092l.696-1.707.638 1.707H9.092zm2.523.488l.002-.016a.469.469 0 0 0-.127-.32l-1.046-2.8a.69.69 0 0 0-.627-.474.696.696 0 0 0-.653.447l-1.661 4.075a.472.472 0 0 0 .874.357l.33-.813h2.07l.299.8a.472.472 0 1 0 .884-.33l-.345-.926zM8.293 9.302a.472.472 0 0 0-.471-.472H4.577a.472.472 0 1 0 0 .944h1.16v3.736a.472.472 0 0 0 .944 0V9.774h1.14c.261 0 .472-.212.472-.472z"/>
                </svg>
              </div>
              <div class="card-content">
                <h3>카카오톡 비즈보드</h3>
                <p>카카오 채팅 목록 팁/콘텐츠 소비 영역에 광고 노출</p>
                <div class="tags">
                  <span>카카오톡</span>
                  <span>다음</span>
                  <span>카카오 서비스</span>
                </div>
              </div>
            </div>

            <div class="marketing-card">
              <div class="card-icon blog">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z" />
                </svg>
              </div>
              <div class="card-content">
                <h3>블로그 마케팅 프로그램</h3>
                <p>서로이웃 자동 관리 및 추가, 체계적인 블로그 운영</p>
                <div class="tags">
                  <span>서로이웃 자동추가</span>
                  <span>이웃 관리</span>
                  <span>통계 분석</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 홈페이지 제작 -->
        <div v-if="activeTab === 'website'" class="tab-panel">
          <!-- 샘플 홈페이지 -->
          <div class="section">
            <h2 class="section-title">샘플 홈페이지</h2>
            <p class="section-desc">다양한 스타일의 분양 홈페이지 샘플을 확인하세요</p>
            <div class="portfolio-grid">
              <a v-for="sample in samples" :key="sample.id" :href="sample.link" target="_blank" class="portfolio-card">
                <div class="portfolio-image">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" />
                  </svg>
                </div>
                <div class="portfolio-content">
                  <h3>{{ sample.name }}</h3>
                  <p>{{ sample.desc }}</p>
                  <span class="view-link">미리보기 →</span>
                </div>
              </a>
            </div>
          </div>

          <!-- 랜딩페이지 -->
          <div class="section">
            <h2 class="section-title">랜딩페이지</h2>
            <p class="section-desc">빠른 제작이 가능한 단일 페이지 웹사이트</p>
            <div class="portfolio-grid">
              <a v-for="landing in landings" :key="landing.id" :href="landing.link" target="_blank" class="portfolio-card">
                <div class="portfolio-image landing">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
                  </svg>
                </div>
                <div class="portfolio-content">
                  <h3>{{ landing.name }}</h3>
                  <p>{{ landing.desc }}</p>
                  <span class="view-link">미리보기 →</span>
                </div>
              </a>
            </div>
          </div>

          <!-- 홈페이지형 블로그 -->
          <div class="section">
            <h2 class="section-title">홈페이지형 블로그</h2>
            <p class="section-desc">네이버 검색 최적화 블로그 제작</p>
            <div class="blog-card">
              <div class="blog-content">
                <div class="blog-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z" />
                  </svg>
                </div>
                <div class="blog-info">
                  <h3>네이버 블로그 기반 홈페이지</h3>
                  <div class="blog-features">
                    <span>네이버 검색 노출 극대화</span>
                    <span>홈페이지형 레이아웃</span>
                    <span>카테고리 구성</span>
                    <span>맞춤형 디자인</span>
                    <span>초기 콘텐츠 10개 작성</span>
                    <span>서로이웃 100명 확보</span>
                    <span>키워드 최적화</span>
                  </div>
                  <div class="blog-price">
                    <span class="price">29만원~</span>
                    <span class="duration">제작기간: 1~2주</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 문의 폼 섹션 -->
      <div class="inquiry-section">
        <div class="inquiry-header">
          <h2>광고 문의하기</h2>
          <p>상담 신청을 남겨주시면 빠르게 연락드리겠습니다</p>
        </div>

        <form @submit.prevent="handleSubmit" class="inquiry-form">
          <div class="form-row">
            <div class="form-group">
              <label>회사명 <span class="required">*</span></label>
              <input v-model="form.company" type="text" placeholder="회사명을 입력하세요" required />
            </div>
            <div class="form-group">
              <label>담당자명 <span class="required">*</span></label>
              <input v-model="form.name" type="text" placeholder="이름을 입력하세요" required />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>연락처 <span class="required">*</span></label>
              <input v-model="form.phone" type="tel" placeholder="010-0000-0000" required />
            </div>
            <div class="form-group">
              <label>이메일 <span class="required">*</span></label>
              <input v-model="form.email" type="email" placeholder="example@example.com" required />
            </div>
          </div>

          <div class="form-group">
            <label>관심 서비스 <span class="required">*</span></label>
            <div class="service-checkboxes">
              <label class="service-checkbox">
                <input v-model="form.services" type="checkbox" value="배너광고" />
                <span class="checkbox-box">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                  </svg>
                </span>
                <span class="checkbox-label">배너 광고</span>
              </label>
              <label class="service-checkbox">
                <input v-model="form.services" type="checkbox" value="공고광고" />
                <span class="checkbox-box">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                  </svg>
                </span>
                <span class="checkbox-label">공고 광고</span>
              </label>
              <label class="service-checkbox">
                <input v-model="form.services" type="checkbox" value="파트너스" />
                <span class="checkbox-box">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                  </svg>
                </span>
                <span class="checkbox-label">파트너스</span>
              </label>
              <label class="service-checkbox">
                <input v-model="form.services" type="checkbox" value="온라인마케팅" />
                <span class="checkbox-box">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                  </svg>
                </span>
                <span class="checkbox-label">온라인 마케팅</span>
              </label>
              <label class="service-checkbox">
                <input v-model="form.services" type="checkbox" value="홈페이지제작" />
                <span class="checkbox-box">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                  </svg>
                </span>
                <span class="checkbox-label">홈페이지 제작</span>
              </label>
            </div>
            <p v-if="serviceError" class="error">최소 1개 이상 선택해주세요</p>
          </div>

          <div class="form-group">
            <label>예산 범위</label>
            <select v-model="form.budget">
              <option value="">선택하세요</option>
              <option value="100만원 미만">100만원 미만</option>
              <option value="100-300만원">100-300만원</option>
              <option value="300-500만원">300-500만원</option>
              <option value="500-1000만원">500-1000만원</option>
              <option value="1000만원 이상">1000만원 이상</option>
              <option value="협의">협의 필요</option>
            </select>
          </div>

          <div class="form-group">
            <label>문의 내용 <span class="required">*</span></label>
            <textarea v-model="form.message" placeholder="문의하실 내용을 상세히 작성해주세요" rows="6" required></textarea>
          </div>

          <div class="form-group">
            <label>첨부파일</label>
            <div class="file-input">
              <input id="file" type="file" @change="handleFileChange" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" />
              <label for="file">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13" />
                </svg>
                <span v-if="fileName">{{ fileName }}</span>
                <span v-else>파일 선택 (최대 5MB)</span>
              </label>
            </div>
            <p class="helper">PDF, JPG, PNG, DOC 파일만 가능</p>
          </div>

          <div class="form-group">
            <label class="privacy-checkbox">
              <input v-model="form.privacyAgreed" type="checkbox" required />
              <span class="checkbox-box">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
              </span>
              <span class="checkbox-label">개인정보 수집 및 이용에 동의합니다 <span class="required">*</span></span>
            </label>
            <p class="helper">수집 항목: 회사명, 담당자명, 연락처, 이메일 / 이용 목적: 상담 및 광고 제안</p>
          </div>

          <button type="submit" class="submit-button" :disabled="loading">
            <span v-if="loading">전송 중...</span>
            <span v-else>문의 신청</span>
          </button>
        </form>
      </div>

      <!-- CTA -->
      <div class="cta-section">
        <h3>빠른 상담이 필요하신가요?</h3>
        <div class="cta-buttons">
          <a href="tel:1877-4088" class="cta-button">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
            </svg>
            1877-4088
          </a>
          <a href="mailto:info@dudals.co.kr" class="cta-button">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
            </svg>
            info@dudals.co.kr
          </a>
        </div>
        <p class="cta-hours">평일 09:00 - 18:00 (주말 및 공휴일 휴무)</p>
      </div>
    </div>

    <!-- 성공 모달 -->
    <div v-if="showSuccessModal" class="modal" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="success-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h3>문의가 접수되었습니다</h3>
        <p>빠른 시일 내에 연락드리겠습니다</p>
        <button @click="closeModal" class="modal-button">확인</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { collection, addDoc, serverTimestamp } from 'firebase/firestore'
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage'
import { db, storage } from '@/services/firebase'

const activeTab = ref('platform')
const form = ref({
  company: '',
  name: '',
  phone: '',
  email: '',
  services: [],
  budget: '',
  message: '',
  privacyAgreed: false
})
const fileName = ref('')
const file = ref(null)
const loading = ref(false)
const showSuccessModal = ref(false)
const serviceError = ref(false)

const tabs = [
  {
    id: 'platform',
    name: '분양쟁이 광고',
    icon: 'M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z'
  },
  {
    id: 'marketing',
    name: '온라인 마케팅',
    icon: 'M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z'
  },
  {
    id: 'website',
    name: '홈페이지 제작',
    icon: 'M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25'
  }
]

// 샘플 홈페이지 데이터
const samples = [
  { id: 1, name: '샘플 A', desc: '모던한 디자인의 프리미엄 홈페이지', link: 'https://www.naver.com' },
  { id: 2, name: '샘플 B', desc: '깔끔하고 심플한 스타일', link: 'https://www.naver.com' },
  { id: 3, name: '샘플 C', desc: '고급스러운 분양 홈페이지', link: 'https://www.naver.com' },
  { id: 4, name: '샘플 D', desc: '차별화된 레이아웃 디자인', link: 'https://www.naver.com' }
]

// 랜딩페이지 데이터
const landings = [
  { id: 1, name: '랜딩페이지 A', desc: '빠른 제작, 효과적인 전달', link: 'https://www.naver.com' },
  { id: 2, name: '랜딩페이지 B', desc: '단일 페이지 집중 노출', link: 'https://www.naver.com' },
  { id: 3, name: '랜딩페이지 C', desc: '모바일 최적화 디자인', link: 'https://www.naver.com' }
]

const handleFileChange = (e) => {
  const selectedFile = e.target.files[0]
  if (selectedFile) {
    if (selectedFile.size > 5 * 1024 * 1024) {
      alert('파일 크기는 5MB를 초과할 수 없습니다')
      e.target.value = ''
      return
    }
    file.value = selectedFile
    fileName.value = selectedFile.name
  }
}

const handleSubmit = async () => {
  if (form.value.services.length === 0) {
    serviceError.value = true
    return
  }
  serviceError.value = false
  loading.value = true

  try {
    let fileUrl = ''
    if (file.value) {
      const fileRef = storageRef(storage, `contact-files/${Date.now()}_${file.value.name}`)
      await uploadBytes(fileRef, file.value)
      fileUrl = await getDownloadURL(fileRef)
    }

    await addDoc(collection(db, 'contacts'), {
      company: form.value.company,
      name: form.value.name,
      phone: form.value.phone,
      email: form.value.email,
      services: form.value.services,
      budget: form.value.budget || '미정',
      message: form.value.message,
      fileUrl: fileUrl,
      fileName: fileName.value || '',
      status: 'pending',
      createdAt: serverTimestamp(),
      privacyAgreed: form.value.privacyAgreed
    })

    showSuccessModal.value = true
    form.value = {
      company: '',
      name: '',
      phone: '',
      email: '',
      services: [],
      budget: '',
      message: '',
      privacyAgreed: false
    }
    fileName.value = ''
    file.value = null
  } catch (error) {
    console.error('Error:', error)
    alert('문의 접수 중 오류가 발생했습니다')
  } finally {
    loading.value = false
  }
}

const closeModal = () => {
  showSuccessModal.value = false
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.contact-view {
  min-height: 100vh;
  background: #f8fafc;
}

/* Hero */
.hero {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 60px 20px;
  text-align: center;
}

.hero-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 12px;
}

.hero-subtitle {
  font-size: 1.125rem;
  color: #64748b;
}

/* Container */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Tabs */
.tabs-wrapper {
  padding: 32px 0;
  display: flex;
  justify-content: center;
}

.tabs {
  display: inline-flex;
  background: white;
  border-radius: 12px;
  padding: 6px;
  gap: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: transparent;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;
}

.tab svg {
  width: 20px;
  height: 20px;
}

.tab:hover {
  background: #f8fafc;
}

.tab.active {
  background: #3b82f6;
  color: white;
}

/* Tab Content */
.tab-panel {
  animation: fadeIn 0.3s;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.section {
  margin-bottom: 60px;
}

.section-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 24px;
}

/* Cards Grid */
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.service-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: relative;
}

.service-card.featured {
  border: 2px solid #3b82f6;
}

.card-badge {
  position: absolute;
  top: 16px;
  right: 16px;
  padding: 4px 12px;
  background: #3b82f6;
  color: white;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
}

.card-header h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 12px;
}

.price {
  font-size: 2rem;
  font-weight: 800;
  color: #3b82f6;
}

.price span {
  font-size: 1rem;
  color: #64748b;
  font-weight: 500;
}

.features {
  list-style: none;
  padding: 0;
  margin: 20px 0 0;
}

.features li {
  padding: 10px 0;
  color: #475569;
  font-size: 0.95rem;
  border-bottom: 1px solid #f1f5f9;
}

.features li:last-child {
  border-bottom: none;
}

.features li:before {
  content: "✓";
  color: #10b981;
  font-weight: bold;
  margin-right: 10px;
}

/* Comparison Table */
.comparison-table {
  overflow-x: auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  background: #f8fafc;
}

th, td {
  padding: 16px;
  text-align: center;
  border-bottom: 1px solid #f1f5f9;
}

th {
  font-weight: 700;
  color: #1e293b;
}

td {
  color: #475569;
}

td.label {
  text-align: left;
  font-weight: 600;
  color: #1e293b;
}

.highlight {
  background: #eff6ff;
  color: #3b82f6;
  font-weight: 600;
}

.badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
}

.badge.urgent {
  background: #fee2e2;
  color: #dc2626;
}

.badge.pick {
  background: #ede9fe;
  color: #7c3aed;
}

.badge.premium {
  background: #fef3c7;
  color: #92400e;
}

/* Partners Card */
.partners-card {
  background: white;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.partners-info h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
}

/* Marketing Grid */
.marketing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 24px;
}

.marketing-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  gap: 20px;
}

.card-icon {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.card-icon svg {
  width: 32px;
  height: 32px;
}

.card-icon.youtube { background: #fee2e2; color: #dc2626; }
.card-icon.instagram { background: #fce7f3; color: #db2777; }
.card-icon.facebook { background: #dbeafe; color: #2563eb; }
.card-icon.naver { background: #dcfce7; }
.card-icon.google { background: #fef3c7; }
.card-icon.kakao { background: #fef9c3; color: #000; }
.card-icon.blog { background: #e0e7ff; color: #4f46e5; }

.naver-logo {
  font-size: 2rem;
  font-weight: 900;
  color: #03C75A;
}

.card-content h3 {
  font-size: 1.125rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
}

.card-content p {
  font-size: 0.95rem;
  color: #64748b;
  margin-bottom: 12px;
  line-height: 1.5;
}

.tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.tags span {
  padding: 4px 10px;
  background: #f1f5f9;
  color: #475569;
  border-radius: 20px;
  font-size: 0.8125rem;
  font-weight: 500;
}

/* Website Grid */
.section-desc {
  color: #64748b;
  font-size: 1rem;
  margin-bottom: 32px;
}

/* Portfolio Grid */
.portfolio-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
}

.portfolio-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
  text-decoration: none;
  display: block;
}

.portfolio-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.portfolio-image {
  height: 200px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.portfolio-image.landing {
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
}

.portfolio-image svg {
  width: 64px;
  height: 64px;
  color: white;
  opacity: 0.9;
}

.portfolio-content {
  padding: 24px;
}

.portfolio-content h3 {
  font-size: 1.125rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
}

.portfolio-content p {
  font-size: 0.95rem;
  color: #64748b;
  margin-bottom: 16px;
}

.view-link {
  display: inline-block;
  color: #3b82f6;
  font-weight: 600;
  font-size: 0.95rem;
}

.portfolio-card:hover .view-link {
  color: #2563eb;
}

/* Blog Card */
.blog-card {
  background: white;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.blog-content {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.blog-icon {
  width: 72px;
  height: 72px;
  background: #eff6ff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.blog-icon svg {
  width: 40px;
  height: 40px;
  color: #3b82f6;
}

.blog-info {
  flex: 1;
}

.blog-info h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 20px;
}

.blog-features {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
}

.blog-features span {
  padding: 8px 16px;
  background: #f1f5f9;
  color: #475569;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
}

.blog-price {
  display: flex;
  align-items: center;
  gap: 20px;
  padding-top: 20px;
  border-top: 2px solid #f1f5f9;
}

.blog-price .price {
  font-size: 1.75rem;
  font-weight: 800;
  color: #3b82f6;
}

.blog-price .duration {
  font-size: 0.95rem;
  color: #64748b;
}

/* Inquiry Section */
.inquiry-section {
  background: white;
  border-radius: 12px;
  padding: 48px;
  margin: 60px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.inquiry-header {
  text-align: center;
  margin-bottom: 40px;
}

.inquiry-header h2 {
  font-size: 2rem;
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 12px;
}

.inquiry-header p {
  color: #64748b;
}

.inquiry-form {
  max-width: 800px;
  margin: 0 auto;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 0.95rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
}

.required {
  color: #dc2626;
}

input, select, textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: border-color 0.2s;
}

input:focus, select:focus, textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

textarea {
  resize: vertical;
}

/* Service Checkboxes */
.service-checkboxes {
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  overflow-x: auto;
}

.service-checkbox {
  position: relative;
  display: inline-flex !important;
  flex-direction: row !important;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.service-checkbox:hover {
  border-color: #3b82f6;
  background: #f8fafc;
}

.service-checkbox input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.checkbox-box {
  width: 20px;
  height: 20px;
  border: 2px solid #cbd5e1;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
  background: white;
}

.checkbox-box svg {
  width: 14px;
  height: 14px;
  color: white;
  opacity: 0;
  transition: opacity 0.2s;
}

.service-checkbox input:checked ~ .checkbox-box {
  background: #3b82f6;
  border-color: #3b82f6;
}

.service-checkbox input:checked ~ .checkbox-box svg {
  opacity: 1;
}

.service-checkbox input:checked ~ .checkbox-label {
  color: #1e293b;
  font-weight: 600;
}

.checkbox-label {
  font-size: 0.95rem;
  color: #64748b;
  font-weight: 500;
  transition: all 0.2s;
}

/* Privacy Checkbox */
.privacy-checkbox {
  position: relative;
  display: flex !important;
  flex-direction: row !important;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 0;
}

.privacy-checkbox:hover {
  border-color: #3b82f6;
  background: #eff6ff;
}

.privacy-checkbox input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.privacy-checkbox input:checked ~ .checkbox-box {
  background: #3b82f6;
  border-color: #3b82f6;
}

.privacy-checkbox input:checked ~ .checkbox-box svg {
  opacity: 1;
}

.privacy-checkbox input:checked ~ .checkbox-label {
  color: #1e293b;
  font-weight: 600;
}

.privacy-checkbox .checkbox-label {
  line-height: 1.5;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
}

.checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.checkbox:hover {
  background: #f1f5f9;
}

.checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #3b82f6;
}

.checkbox span {
  font-size: 0.95rem;
  color: #475569;
  font-weight: 500;
}

.file-input {
  position: relative;
}

.file-input input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.file-input label {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.file-input label:hover {
  background: #f1f5f9;
  border-color: #3b82f6;
}

.file-input svg {
  width: 20px;
  height: 20px;
  color: #64748b;
}

.helper {
  margin-top: 6px;
  font-size: 0.875rem;
  color: #64748b;
}

.error {
  margin-top: 6px;
  font-size: 0.875rem;
  color: #dc2626;
}

.submit-button {
  width: 100%;
  padding: 16px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.125rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 8px;
}

.submit-button:hover:not(:disabled) {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* CTA Section */
.cta-section {
  text-align: center;
  padding: 48px 24px;
  background: white;
  border-radius: 12px;
  margin-bottom: 60px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.cta-section h3 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 24px;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.cta-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 28px;
  background: #3b82f6;
  color: white;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
}

.cta-button:hover {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.cta-button svg {
  width: 20px;
  height: 20px;
}

.cta-hours {
  color: #64748b;
  font-size: 0.95rem;
}

/* Modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 16px;
  padding: 40px;
  max-width: 400px;
  width: 100%;
  text-align: center;
}

.success-icon {
  width: 64px;
  height: 64px;
  background: #dcfce7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.success-icon svg {
  width: 32px;
  height: 32px;
  color: #16a34a;
}

.modal-content h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 12px;
}

.modal-content p {
  color: #64748b;
  margin-bottom: 24px;
}

.modal-button {
  padding: 12px 32px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.modal-button:hover {
  background: #2563eb;
}

/* Responsive */
@media (max-width: 768px) {
  .hero-title {
    font-size: 1.75rem;
  }

  .tabs {
    flex-direction: column;
    width: 100%;
  }

  .tab {
    width: 100%;
    justify-content: center;
  }

  .cards-grid,
  .marketing-grid,
  .portfolio-grid {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .inquiry-section {
    padding: 32px 20px;
  }

  .service-checkboxes,
  .checkbox-grid {
    grid-template-columns: 1fr;
  }

  .cta-buttons {
    flex-direction: column;
  }

  .cta-button {
    width: 100%;
    justify-content: center;
  }

  .blog-content {
    flex-direction: column;
  }

  .blog-icon {
    width: 60px;
    height: 60px;
  }

  .blog-icon svg {
    width: 32px;
    height: 32px;
  }

  .blog-price {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}
</style>